// Actions for the My Content per-type show/hide (eye toggle). The state is a
// list of content-type keys that are currently HIDDEN from the map. Session-only
// (blacklisted from redux-persist) — resets to all-visible on reload.

export const TOGGLE_CONTENT_TYPE_VISIBILITY = 'TOGGLE_CONTENT_TYPE_VISIBILITY'
export const CONTENT_TYPES_VISIBILITY_RESET = 'CONTENT_TYPES_VISIBILITY_RESET'

// contentType is one of: 'markers', 'huntStands', 'photos', 'shapes', 'tracks', 'routes'
export const toggleContentTypeVisibility = contentType => ({
  type: TOGGLE_CONTENT_TYPE_VISIBILITY,
  payload: contentType,
})

export const resetContentTypesVisibility = () => ({
  type: CONTENT_TYPES_VISIBILITY_RESET,
})
